import moment from 'moment';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';

import { DISPLAY_DATE_FORMAT_LONG, INPUT_DATE_FORMAT_SHORT } from '../../../config/helpers';
import formatPrice from '../../../util/formatPrice';

import Button from '../Atoms/Button';
import Picture from '../Picture';

const propTypes = exact({
  atolProtectedText: PropTypes.string,
  durationText: PropTypes.string,
  callToBookText: PropTypes.string,
  ctaURL: PropTypes.string,
  currencySymbol: PropTypes.string.isRequired,
  description: PropTypes.string,
  fromDate: PropTypes.string,
  isCallToBook: PropTypes.bool,
  preferredCardImage: PropTypes.object,
  price: PropTypes.number.isRequired,
  secondDescription: PropTypes.string,
  showAtolLabel: PropTypes.bool,
  title: PropTypes.string,
  toDate: PropTypes.string,
  totalPriceText: PropTypes.string,
});

const defaultProps = {
  atolProtectedText: null,
  durationText: 'Duration',
  callToBookText: 'Please call to book',
  ctaURL: null,
  description: null,
  fromDate: null,
  isCallToBook: false,
  preferredCardImage: null,
  secondDescription: null,
  showAtolLabel: false,
  title: '',
  toDate: null,
  totalPriceText: 'Total Price',
};

function PackageSummary(props) {
  return (
    <div className="PackageSummary">
      <div className="PackageSummary_wrap">
        <div className="PackageSummary_body">
          <div className="PackageSummary_item PackageSummary_item-overview">
            <div className="PackageSummary_content">
              <h3 className="PackageSummary_title">{props.title}</h3>
              {props.fromDate && props.toDate && (
                <>
                  <div className="PackageSummary_date">
                    {`${moment(props.fromDate).format(DISPLAY_DATE_FORMAT_LONG)} - ${moment(
                      props.toDate
                    ).format(DISPLAY_DATE_FORMAT_LONG)}`}
                  </div>
                  <div className="PackageSummary_date-short">
                    {`${moment(props.fromDate).format(INPUT_DATE_FORMAT_SHORT)} - ${moment(
                      props.toDate
                    ).format(INPUT_DATE_FORMAT_SHORT)}`}
                  </div>
                </>
              )}
              {props.description && (
                <div className="PackageSummary_description">{props.description}</div>
              )}
              {props.secondDescription && (
                <div className="PackageSummary_description">{props.secondDescription}</div>
              )}
              {props.showAtolLabel && (
                <div className="PackageSummary_atolLabel">{props.atolProtectedText}</div>
              )}
            </div>
          </div>
          {props.fromDate && props.toDate && (
            <div className="PackageSummary_item PackageSummary_item-date">
              <div className="PackageSummary_content">
                <div className="PackageSummary_dateTitle-detached">{props.durationText}:</div>
                <div className="PackageSummary_date-detached">
                  {`${moment(props.fromDate).format(INPUT_DATE_FORMAT_SHORT)} - ${moment(
                    props.toDate
                  ).format(INPUT_DATE_FORMAT_SHORT)}`}
                </div>
              </div>
            </div>
          )}
          <div className="PackageSummary_item PackageSummary_item-price">
            <div className="PackageSummary_content">
              {!props.isCallToBook && (
                <>
                  <div className="PackageSummary_priceTitle">{props.totalPriceText}:</div>
                  <div className="PackageSummary_price">
                    {props.currencySymbol}
                    {formatPrice(props.price)}
                  </div>
                </>
              )}
              {props.isCallToBook && (
                <div className="PackageSummary_callToBook">{props.callToBookText}</div>
              )}
            </div>
          </div>
          {(props.ctaURL || props.preferredCardImage) && (
            <div className="PackageSummary_item PackageSummary_item-cta">
              <div className="PackageSummary_content">
                {props.ctaURL && (
                  <Button
                    blockName="PackageSummary_button"
                    elementType="link"
                    modifier="fill"
                    text="Book now"
                    url={props.ctaURL}
                  />
                )}
                {props.preferredCardImage && (
                  <div className="PackageSummary_preferredCard">
                    <Picture
                      {...props.preferredCardImage}
                      sizes={[
                        ['150', 1], // from 0
                        ['150', 1], // from 440
                        ['150', 1], // from 768
                        ['150', 1], // from 1024
                        ['150', 1], // from 1440
                      ]}
                    />
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

PackageSummary.propTypes = propTypes;
PackageSummary.defaultProps = defaultProps;

export default PackageSummary;
